export const SET_MEDIA_LIBRARY_FILTER = 'MEDIA_LIBRARY/SET_FILTER';
export const CLEAR_MEDIA_LIBRARY_FILTERS = 'MEDIA_LIBRARY/CLEAR_FILTERS';
export const REMOVE_MEDIA_LIBRARY_FILTER = 'MEDIA_LIBRARY/REMOVE_FILTER';
export const FETCH_MEDIA_LIBRARY = 'MEDIA_LIBRARY/FETCH_REQUEST';
export const FETCH_MEDIA_LIBRARY_SUCCESS = 'MEDIA_LIBRARY/FETCH_SUCCESS';
export const FETCH_MEDIA_LIBRARY_FAILURE = 'MEDIA_LIBRARY/FETCH_FAILURE';

export const UPDATE_MEDIA_LIBRARY = 'MEDIA_LIBRARY/UPDATE_REQUEST';
export const UPDATE_MEDIA_LIBRARY_SUCCESS = 'MEDIA_LIBRARY/UPDATE_SUCCESS';
export const UPDATE_MEDIA_LIBRARY_FAILURE = 'MEDIA_LIBRARY/UPDATE_FAILURE';

export const DELETE_MEDIA_LIBRARY = 'MEDIA_LIBRARY/DELETE_REQUEST';
export const DELETE_MEDIA_LIBRARY_SUCCESS = 'MEDIA_LIBRARY/DELETE_SUCCESS';
export const DELETE_MEDIA_LIBRARY_FAILURE = 'MEDIA_LIBRARY/DELETE_FAILURE';

export const OPEN_MEDIA_LIBRARY_DRAWER = 'MEDIA_LIBRARY/OPEN_DRAWER';
export const CLOSE_MEDIA_LIBRARY_DRAWER = 'MEDIA_LIBRARY/CLOSE_DRAWER';

export const OPEN_UPLOAD_MODAL = 'MEDIA_LIBRARY/UPLOAD_MODAL/OPEN';
export const CLOSE_UPLOAD_MODAL = 'MEDIA_LIBRARY/UPLOAD_MODAL/CLOSE';

export const UPLOAD_MEDIA_LIBRARY_ITEMS = 'MEDIA_LIBRARY/UPLOAD_REQUEST';
export const UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS = 'MEDIA_LIBRARY/UPLOAD_SUCCESS';
export const UPLOAD_MEDIA_LIBRARY_ITEMS_FAILURE = 'MEDIA_LIBRARY/UPLOAD_FAILURE';

export const ADD_ITEM_TO_MEDIA_LIBRARY = 'MEDIA_LIBRARY/ADD_ITEM_REQUEST';
export const ADD_ITEM_FROM_MEDIA_LIBRARY_SUCCESS = 'MEDIA_LIBRARY/ADD_ITEM_SUCCESS';
export const ADD_ITEM_FROM_MEDIA_LIBRARY_FAILURE = 'MEDIA_LIBRARY/ADD_ITEM_FAILURE';
